module.exports = __webpack_public_path__ + "static/media/PICT0129-04.6da6e040.jpg";